import { useFormContext, Controller } from 'react-hook-form';
import { Grid, Typography, Card, CardContent, Checkbox, FormControl, FormGroup, FormControlLabel, FormHelperText } from '@mui/material';
import { IApplicationFormStep2 } from '../utils';

export const StepCommunicationPreferences = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IApplicationFormStep2>();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <FormGroup row>
              <FormControlLabel
                label='By default we will send you SMS notifications about potential fraudulent transactions. If you would not like to receive
                  fraudulent SMS alerts please tick here.'
                control={
                  <Controller
                    name='fraudSMS'
                    control={control}
                    render={({ field }) => <Checkbox {...field} color='primary' checked={field.value} />}
                  />
                }
              />
              <FormControlLabel
                label='By default we will send you SMS notifications when your spending reaches 80% of your credit limit. If you would not like
                  to receive SMS notifications when your spending reaches 80% of your credit limit please tick here.'
                control={
                  <Controller
                    name='creditLimit80PerCentSMS'
                    control={control}
                    render={({ field }) => <Checkbox {...field} color='primary' checked={field.value} />}
                  />
                }
              />
              <FormControlLabel
                label='If you would like to receive SMS notifications for all card transactions please tick here.'
                control={
                  <Controller
                    name='allTransactionsSMS'
                    control={control}
                    render={({ field }) => <Checkbox {...field} color='primary' checked={field.value} />}
                  />
                }
              />
            </FormGroup>
            <Typography variant='h6' paragraph>
              DATA PROTECTION
            </Typography>
            <Typography paragraph>
              We will process the data provided in this Application Form and any other data which you subsequently give to us in any manner, in line
              with our Privacy Notice, a summarized version of which can be found on page 3. We also strongly advise that you read our full Privacy
              Notice which can be found on our website or you can ask us for a copy.
            </Typography>
            <Typography variant='h6' paragraph>
              MARKETING PREFERENCE
            </Typography>
            <Typography paragraph>
              From time-to-time, we (or a third party on our behalf) would like to inform you by post, telephone, e-mail or any other electronic means
              about our future products and services.
            </Typography>
            <FormGroup>
              <FormControlLabel
                label='Please tick this box if you do not want to receive such information'
                control={
                  <Controller
                    name='marketing'
                    control={control}
                    render={({ field }) => <Checkbox {...field} color='primary' checked={field.value} />}
                  />
                }
              />
              <FormControl error={!!errors.acceptedTC}>
                <FormControlLabel
                  control={
                    <Controller
                      name='acceptedTC'
                      control={control}
                      rules={{ required: 'T&C is required' }}
                      render={({ field }) => <Checkbox {...field} color='primary' checked={field.value} />}
                    />
                  }
                  label='I confirm that I have read and accept the Terms and Conditions and Privacy Notice of each Insignia Cards Limited and Insignia Lifestyle Boutique Limited. *'
                />
                {errors.acceptedTC && <FormHelperText>{errors.acceptedTC.message}</FormHelperText>}
              </FormControl>
            </FormGroup>
            <Grid item xs={12} style={{ marginTop: '1rem' }}>
              <Typography variant='body1'>** Definition of ‘Politically Exposed Persons’</Typography>
              <Typography variant='body1'>
                Politically exposed persons are individuals who have been entrusted with prominent public functions whose position in public life may
                make them vulnerable to corruption. The definition extends to immediate family members and persons known to be close associates.
              </Typography>
              <Typography variant='body1'>(a) the term ‘prominent public functions’ shall include the following:</Typography>
              <Typography variant='body1'>
                (i) Heads of State, Heads of Government, Ministers and Deputy and Assistant Ministers and Parliamentary Secretaries;
              </Typography>
              <Typography variant='body1'>(ii) Members of Parliament;</Typography>
              <Typography variant='body1'>
                (iii) members of the Courts or of other high-level judicial bodies whose decisions are not subject to further appeal, except in
                exceptional circumstances;
              </Typography>
              <Typography variant='body1'>(iv) members of courts of auditors, Audit Committees or of the boards of central banks;</Typography>
              <Typography variant='body1'>(v) ambassadors, charges d’affaires and other high-ranking officers in the armed forces;</Typography>
              <Typography variant='body1'>
                (vi) members of the administrative, management or boards of State-owned corporations, and where applicable, for the purposes of
                subparagraphs (i) to (v), shall include positions held at the Community or international level but shall exclude middle ranking or
                more junior official positions.
              </Typography>
              <Typography variant='body1'>(b) the term ‘immediate family members’ shall include the following:</Typography>
              <Typography variant='body1'>(i) the spouse, or any partner recognized by national law as equivalent to the spouse;</Typography>
              <Typography variant='body1'>(ii) the children and their spouses or partners; and</Typography>
              <Typography variant='body1'>(iii) the parents.</Typography>
              <Typography variant='body1'>(c) the term ‘persons known to be close associates’ shall include the following:</Typography>
              <Typography variant='body1'>
                (i) a natural person known to have joint beneficial ownership of a body corporate or any other form of legal arrangement, or any other
                close business relations with that politically exposed person;
              </Typography>
              <Typography variant='body1'>
                (ii) a natural person who has sole beneficial ownership of a body corporate or any other form of legal arrangement that is known to
                have been established for the benefit of that politically exposed person.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
